import React, {useState} from 'react'
import {
    Alert,
    Box,
    Button, Container,
    Grid,
    Link,
    TextField, Typography
} from "@mui/material";
import {useAuth} from "./context/AuthContext";
import {Navigate, useNavigate, useSearchParams} from "react-router-dom";
import {famtrailApi} from '../services/FamtrailApi'
import { parseJwt, handleLogError } from '../services/Helpers'
import Logo from "./LogoBeta";
import {useTranslation} from "react-i18next";

const PasswordReset = () => {

    const {t} = useTranslation();

    const navigate = useNavigate();

    const [searchParams] = useSearchParams();

    const [password, setPassword] = useState("")
    const [isError, setIsError] = useState(false)

    const handleInputChange = (name, value) => {
        if (name === 'password') {
            setPassword(value)
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault()

        if (!password) {
            setIsError(true)
            return
        }

        try {
            const data = {password: password, code: searchParams.get("c")};
            await famtrailApi.resetPassword(data);

            setPassword('')
            setIsError(false)
        } catch (error) {
            handleLogError(error)
            setIsError(true)
            return
        }
        navigate("/password-changed");
    }

    return (
            <Container component="main" maxWidth="xs">
                <Box
                    sx={{
                        marginTop: 8,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >
                    <Typography component="h1" variant="h5" mt="20px">
                        {t('passwordReset.title')}
                    </Typography>
                    <Typography mt={4} mb={1}>
                        {t('passwordReset.text')}
                    </Typography>
                    <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            name="password"
                            label={t('passwordReset.label')}
                            type="password"
                            id="password"
                            autoComplete="current-password"
                            inputProps={{ maxLength: 255 }}
                            value={password}
                            onChange = {(e) => {
                                handleInputChange(e.target.name, e.target.value);
                            }}
                        />
                        {isError && <Alert severity="error" variant="filled">{'Password must be at least 8 characters long'}</Alert>}
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            size="large"
                            sx={{ mt: 3, mb: 2, textTransform: 'none', boxShadow: 'none'}}
                        >
                            {t('passwordReset.submitButton')}
                        </Button>
                    </Box>
                </Box>
            </Container>
    );
}

export default PasswordReset